import { put, takeEvery } from 'redux-saga/effects'
import { AxiosResponse } from 'axios'

import { OrderAPI } from 'primsell-shared-layer/api'
import { OrderActions, StripeActions } from 'features'

import { IResponseCreateOrder, WrappedResponse } from 'primsell-shared-layer/types'
import { CampaignPublicActions, ModalActions } from 'primsell-shared-layer/features'
import { ModalVariantE } from '../../modal/components/modal-controller/modal.enums'
import { PaymentErrorsE } from '../components/modals/error-modal/error-modal.types'

export function* createOrderSaga(action: ReturnType<typeof OrderActions.createOrderRequest>): Generator {
  try {
    const {
      data: {
        data: { clientSecret, accountId, expiredAt },
      },
    }: AxiosResponse = (yield OrderAPI.createOrder(action.payload)) as WrappedResponse<IResponseCreateOrder>

    yield put(OrderActions.createOrderResponse({ expPaymentDate: expiredAt }))
    yield put(StripeActions.setClientSecret({ clientSecret }))
    yield put(StripeActions.setAccountId({ accountId }))
  } catch (error: any) {
    switch (error.response.data.errorCode) {
      case PaymentErrorsE.PURCHASE_ORDER_IN_PROGRESS:
        yield put(
          ModalActions.openModal({
            variant: ModalVariantE.ERROR_MODAL,
            state: { errorType: PaymentErrorsE.PURCHASE_ORDER_IN_PROGRESS },
          })
        )
        break

      case PaymentErrorsE.PURCHASE_LIMIT_EXCEEDED:
        yield put(
          ModalActions.openModal({
            variant: ModalVariantE.ERROR_MODAL,
            state: { errorType: PaymentErrorsE.PURCHASE_LIMIT_EXCEEDED },
          })
        )
        break

      default:
        break
    }

    yield put(OrderActions.createOrderError({ errorMessage: error.response.data.errorCode }))

    const newAmount = Number(error.response.data?.errorCode?.split(' ')?.[1])

    if (newAmount && !isNaN(+newAmount)) {
      yield put(CampaignPublicActions.changeOrderInStock({ inStock: newAmount }))
    }
  }
}

function* orderSagas(): Generator {
  yield takeEvery(OrderActions.createOrderRequest, createOrderSaga)
}

export { orderSagas }
